import { useLocation } from "react-router-dom"
import BackLink from "../../components/BackLink"
import PaiementForm from "../../components/payment/paymentForm"

const PaymentPlan=()=>{
    const location=useLocation()
    const plan=location.state.plan
    const free=location.state.free
return(
    <div className="container mt-40">
    <BackLink/>
    <PaiementForm plan={plan} from="account" free={free}/>
    </div>
)
}
export default PaymentPlan